import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatMixService } from '@app/shared/services/mat-mix.service';

@Component({
  selector: 'app-material-list',
  templateUrl: './material-list.component.html',
  styleUrls: ['./material-list.component.css']
})
export class MaterialListComponent implements OnInit {
  
  MaterialList: any[] = [];
  selectedIds: string[] = [];

  constructor(private matMixService: MatMixService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.getAllMaterials();
  }

  getAllMaterials() {
    this.matMixService.getAllMatMix().subscribe(
      (res: any) => {
        this.MaterialList = res.map((item: any) => ({
          ...item,
          materials: item.Materials
        }));
        this.MaterialList.reverse();
        this.cdr.detectChanges();
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  toggleSelection(id: string) {
    const index = this.selectedIds.indexOf(id);
    if (index === -1) {
      this.selectedIds.push(id);
    } else {
      this.selectedIds.splice(index, 1);
    }
  }

  deleteSelected() {
    if (this.selectedIds.length > 0) {
      const confirmDelete = window.confirm('Are you sure you want to delete the selected materials?');
      
      if (confirmDelete) {
        this.matMixService.deleteAll(this.selectedIds).subscribe(
          () => {
            this.MaterialList = this.MaterialList.filter(item => !this.selectedIds.includes(item._id));
            this.selectedIds = [];
            alert('Selected materials deleted successfully.');
          },
          (err) => {
            console.error(err);
            alert('Failed to delete selected materials.');
          }
        );
      } else {
        // User canceled the deletion
        alert('Deletion canceled.');
      }
    } else {
      alert('No materials selected for deletion.');
    }
  }
  
}
